module.exports = __webpack_public_path__ + "static/img/banner-bg.22fc3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/app/banner-bg.png
// module id = PWuS
// module chunks = 69